import React from 'react';
import { Typography, Box, Container } from '@mui/material';
import { useThemeContext } from '../../context/ThemeContext';
import { Button } from '@mui/joy';





const CustomerJobHero = () => {
  const { isSM, isMD, isLg } = useThemeContext();

  return (
    <>
    
    
      
      <Box>
        {/* Title Section */}
        <Typography
          sx={{
            margin: '80px 0 50px',

            fontSize: '36px',
            fontWeight: 700,
            lineHeight: '43.88px',
            textAlign: 'center',
            color: '#28A745',
          }}
        >
          What You Looking for?
        </Typography>

        {/* Looking Section */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '100px',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '445px',
              height: '242px',
              border: '1px solid #2E2E2E',
              textAlign: 'center',
              borderRadius: '8px',
            }}
          >
            <Typography
              sx={{

                marginTop: '20px',
                fontSize: '24px',
                fontWeight: 500,
                lineHeight: '29.26px',
                textAlign: 'center',
                color: '#28A745',
              }}
            >
              You are a fundi
            </Typography>
            <Box
              sx={{
                height: '80px',
                width: '80px',
                margin: 'auto',
                padding: '10px',
                background: '#28A745',
                borderRadius: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img width={'100%'} height={'100%'} src={`assets/images/${"Layer-1"}.png`} alt="" />

            </Box>
            <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
              <Button
                sx={{
                  display: 'inline-block',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  textDecoration: 'none',
                  background: '#F4F4F4',
                  color: '#2E2E2E',

                  fontSize: '16px',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
                href="/Contact_01"
              >
                Get Started
              </Button>
            </Box>
            <Typography
              sx={{

                fontSize: '11px',
                fontWeight: 400,
                lineHeight: '20px',
                textAlign: 'center',
                color: '#666666',
                marginTop: '10px',
              }}
            >
              Advertise your skills!
            </Typography>
          </Box>

          <Box
            sx={{
              position: 'relative',
              width: '445px',
              height: '242px',
              border: '1px solid #2E2E2E',
              textAlign: 'center',
              borderRadius: '8px',
            }}
          >
            <Typography
              sx={{

                marginTop: '20px',
                fontSize: '24px',
                fontWeight: 500,
                lineHeight: '29.26px',
                textAlign: 'center',
                color: '#28A745',
              }}
            >
              Find a fundi
            </Typography>
            <Box
              sx={{
                height: '80px',
                width: '80px',
                margin: 'auto',
                padding: '10px',
                background: '#28A745',
                borderRadius: '100%',
              }}
            >
              <img width={'100%'} height={'100%'} src={`assets/images/${"Layer-2"}.png`} alt="" />
            </Box>
            <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
              <Button
                sx={{
                  display: 'inline-block',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  textDecoration: 'none',
                  background: '#F4F4F4',
                  color: '#2E2E2E',

                  fontSize: '16px',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
                href="/Contact_01"
              >
                Get Started
              </Button>
            </Box>
            <Typography
              sx={{

                fontSize: '11px',
                fontWeight: 400,
                lineHeight: '20px',
                textAlign: 'center',
                color: '#666666',
                marginTop: '10px',
              }}
            >
              You are looking for a reliable Fundi?
            </Typography>
          </Box>
        </Box>

       
      </Box>
      
      
    </>
  );
};

export default CustomerJobHero;
